import {
  IAddress,
  IMember,
  INewUser
} from "@wingspanhq/users/dist/lib/interfaces";
import { identifyWithCommonFields } from "./analytics";

const getValidAddress = (address?: IAddress) => {
  if (
    address?.addressLine1 &&
    address?.city &&
    address?.state &&
    address?.postalCode &&
    address?.country
  ) {
    return {
      street: address.addressLine2
        ? `${address.addressLine1}, ${address.addressLine2}`
        : address.addressLine1,
      city: address.city,
      state: address.state,
      postalCode: address.postalCode,
      country: address.country
    };
  }
  return undefined;
};

// Called once, right after useInitMemberApp / useInitEmbeddedApp fetch the
// user and member profiles for the first time this session.
export function identifyUser(user: INewUser, member: IMember) {
  // Force a fresh, authenticated boot instead of silently updating whatever
  // (possibly anonymous, possibly unverified) session Intercom already has -
  // Intercom's own guidance is that update() isn't guaranteed to properly
  // re-apply Messenger Security when upgrading a visitor to a known user.
  window.Intercom?.("shutdown");

  const ownerIds = user.userRoles?.ownerIds;
  const formattedOwnerIds =
    ownerIds && ownerIds.length > 0 ? ownerIds.join("-") : undefined;

  const formattedAddress =
    getValidAddress(member.profile?.homeAddress) ||
    getValidAddress(member.profile?.address);

  const company = member.profile?.company;
  const companyName =
    (company as any)?.doingBusinessAs ||
    company?.legalBusinessName ||
    company?.name;

  identifyWithCommonFields(user.userId, {
    email: user.email,
    intercomUserHash: user.intercomUserHash,
    ownerIds: formattedOwnerIds,
    address: formattedAddress,
    website: company?.website || company?.links?.websiteUrl,
    companyName: companyName,
    legalBusinessName: company?.legalBusinessName,
    phone: user.phone?.number
  });
}
